/*
 * Services for working with a teacher's shared flashcard sets
 */

import xhr from 'Common/utils/xhr'

const url = `/api/v1/shared_flashcard_sets`

function getSharedFlashcardSets() {
  return xhr({
    url,
    method: 'GET',
  })
}

/**
 *
 * @param {object} config
 * @param {number} config.flashcardSetId - ID of the flashcard set to share
 * @param {number} config.flashcardCategoryId - ID of the flashcard category to share
 * @param {number} config.teacherId - ID of the teacher the flashcard set belongs to
 * @param {number} [config.classId] - ID of the teacher's class to share to
 * @param {number[]} [config.studentIds = null] - IDs of the class students to share to, if not sharing to whole class
 * @param {string} [config.note = ''] - The note included with the share, if any
 */
function createSharedFlashcardSet({
  flashcardSetId: flashcard_set_id, // eslint-disable-line camelcase
  flashcardCategoryId: flashcard_category_id, // eslint-disable-line camelcase
  teacherId: teacher_id, // eslint-disable-line camelcase
  classId: yumi_class_id, // eslint-disable-line camelcase
  studentIds: student_ids = null,
  note = '',
} = {}) {
  return xhr({
    url,
    method: 'POST',
    data: {
      flashcard_set_id,
      flashcard_category_id,
      teacher_id,
      yumi_class_id,
      student_ids,
      note,
    },
  })
}

/**
 *
 * @param {number} sharedSetId - the ID of the *shared* flashcard set to delete
 */
function deleteSharedFlashcardSet(sharedSetId) {
  return xhr({
    url: `${url}/${sharedSetId}`,
    method: 'DELETE',
  })
}

export default {
  getSharedFlashcardSets,
  createSharedFlashcardSet,
  deleteSharedFlashcardSet,
}
